<script setup lang="ts">
import { computed } from 'vue';

import DispatchJobDiagramDescList from '@/components/descLists/DispatchJobDiagramDescList.vue';
import JobInstructionsDescList from '@/components/descLists/JobInstructionsDescList.vue';
import JobSignatureDescList from '@/components/descLists/JobSignatureDescList.vue';
import SmartDispatchStopsTabs from '@/components/tabs/SmartDispatchStopsTabs.vue';
import DispatchSectionEmptyText from '@/components/texts/DispatchSectionEmptyText.vue';
import { useDispatchDashboardViewStore } from '@/stores/useDispatchDashboardViewStore';

const dispatchDashboardViewStore = useDispatchDashboardViewStore();

const stops = computed(() => {
  return dispatchDashboardViewStore.activatedJob?.stops;
});
</script>

<template>
  <section
    :class="$style.dispatchStopDetailsSection"
    data-testid="dispatchStopDetailsSection"
  >
    <DispatchSectionEmptyText v-if="!dispatchDashboardViewStore.activatedJob" />
    <template v-else>
      <SmartDispatchStopsTabs class="mx-n4" />
      <v-window
        v-model="dispatchDashboardViewStore.stopDetailsActivatedTabNum"
        :class="$style.window"
        :touch="false"
      >
        <v-window-item
          v-for="(stop, stopIndex) in stops"
          :key="stopIndex"
          :value="stopIndex + 1"
          :class="$style.window"
        >
          <div class="my-4">
            <!-- TODO should be fixed after openapi update -->
            <!-- @vue-ignore -->
            <DispatchJobDiagramDescList :stop="stop" />
            <JobInstructionsDescList :text="stop.note_text" class="mt-4" />
            <!-- TODO should be fixed after openapi update -->
            <!-- @vue-ignore -->
            <JobSignatureDescList
              v-if="stop.is_pod_image || stop.pod_time"
              class="mt-4"
              :job-id="dispatchDashboardViewStore.activatedJob.rockhopper_id"
              :job-date="
                dispatchDashboardViewStore.activatedJob.rockhopper_date
              "
              :stop-number="stop.stop_number"
              :pod-name="stop.pod_name"
              :is-pod-image="stop.is_pod_image"
            />
          </div>
        </v-window-item>
      </v-window>
    </template>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchStopDetailsSection {
}
  .window {
    margin: 0 -16px;
    padding: 0 16px;
  }
    .windowItem {
    }
</style>
